module.exports = __webpack_public_path__ + "static/media/4645.4b53f8d9.jpg";